import { render } from "./index.vue?vue&type=template&id=5e3fd653&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=5e3fd653&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3fd653"]])

export default __exports__